export default "__VITE_ASSET__DjDLyZN___"